module.exports = __webpack_public_path__ + "static/media/humphrey-muleba-LOA2mTj1vhc-unsplash.9c05c715.jpg";